import SEO from '../components/SEO';

export default function AppAccessibilityPage() {
  return (
    <div className="flex-1 bg-white py-12">
      <SEO
        title="App Accessibility | Waybook"
        description="Waybook is committed to digital accessibility. Learn about our accessibility features and standards compliance."
        keywords="accessibility, WCAG, screen reader, inclusive design, disability access"
        canonicalUrl="https://www.waybook.me/app-accessibility"
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'App Accessibility',
          description: 'Accessibility features and standards for Waybook',
          url: 'https://www.waybook.me/app-accessibility'
        }}
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold mb-8">App Accessibility</h1>
        
        <div className="prose max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold mb-4">Our Commitment</h2>
            <p className="text-gray-700">
              Waybook is committed to ensuring digital accessibility for people with disabilities. We are 
              continually improving the user experience for everyone and applying relevant accessibility standards.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Accessibility Features</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Screen reader compatibility</li>
              <li>Keyboard navigation support</li>
              <li>High contrast mode</li>
              <li>Adjustable text sizes</li>
              <li>Alternative text for images</li>
              <li>Clear and consistent navigation</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Standards Compliance</h2>
            <p className="text-gray-700">
              We aim to conform to WCAG 2.1 Level AA standards. Our app is designed to be compatible with 
              assistive technologies and follows best practices for accessible design.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Ongoing Improvements</h2>
            <p className="text-gray-700">
              We regularly test our app with users who have disabilities and incorporate their feedback 
              to improve accessibility.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Feedback & Contact</h2>
            <p className="text-gray-700 mb-3">
              If you encounter barriers or need an alternative format, contact us and we’ll
              work to make the content accessible.
            </p>
            <p className="text-gray-700">Email: <a href="mailto:accessibility@waybook.me">accessibility@waybook.me</a></p>
          </section>
        </div>
      </div>
    </div>
  );
}
